export const asArray = (value) => {
    if (Array.isArray(value)) {
        return value
    }
    if (value && typeof value === "object") {
        return Object.values(value)
    }
    return []
}
